import { useEffect, useState } from 'react';

// Flips to true only after the first client render commits, so the very
// first client render matches the server's SSR output exactly (no
// hydration mismatch) before any viewport-dependent logic kicks in.
export default function useMounted() {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	return mounted;
}
